<!-- ----------------------------------------------- -->
<template>
  <transition name="modal" appear>
    <div class="com-modal com-modal-overlay" @click.self="$emit('close')">
      <v-col class="com-pc-graph pa-0" ref="graphBox">
        <v-row class="com-pc-card-header">
          <span class="com-pc-card-title">{{ text.title }}</span>
          <v-spacer></v-spacer>
          <v-btn small text icon color="white" @click="$emit('close')">
            <v-icon>highlight_off</v-icon>
          </v-btn>
        </v-row>
        <v-col class="com-pc-card-contents">
          <v-col class="tm-pc-graph-select-box pa-0">
            <v-row class="pa-1">
              <v-btn
                depressed
                small
                class="ml-1"
                color="success"
                width="80px"
                :outlined="!showRain"
                @click="showRain = !showRain"
                v-if="tmStageList.tmStgDetailInfo.reprnOfcCd"
                >{{ text.showRain }}</v-btn
              >
            </v-row>
          </v-col>
          <v-col>
            <tm-stage-graph
              :width="width"
              :height="height"
              :showRain="showRain"
              :isExpansion="graphSwitch.selectDisp"
              :isHour="graphSwitch.selectTime"
              :isLegend="graphSwitch.isLegendDisp"
            ></tm-stage-graph>
          </v-col>
          <v-col class="pa-0">
            <v-row class="tm-pc-graph-select-box pa-1">
              <v-spacer></v-spacer>
              <v-btn
                tile
                depressed
                small
                color="success"
                width="60px"
                :outlined="graphSwitch.selectDisp === true"
                @click="graphSwitch.selectDisp = false"
                >{{ btn.zoomout }}</v-btn
              >
              <v-btn
                tile
                depressed
                small
                color="success"
                width="60px"
                :outlined="graphSwitch.selectDisp === false"
                @click="graphSwitch.selectDisp = true"
                >{{ btn.zoomin }}</v-btn
              >
              <v-btn
                tile
                depressed
                small
                color="success"
                width="60px"
                :outlined="graphSwitch.selectTime === false"
                @click="graphSwitch.selectTime = true"
                class="ml-1"
                >{{ btn.timehour }}</v-btn
              >
              <v-btn
                tile
                depressed
                small
                color="success"
                width="60px"
                :outlined="graphSwitch.selectTime === true"
                @click="graphSwitch.selectTime = false"
                >{{ btn.time10 }}</v-btn
              >
              <v-btn
                depressed
                small
                color="orange"
                width="60px"
                dark
                :outlined="!graphSwitch.isLegendDisp"
                @click="graphSwitch.isLegendDisp = !graphSwitch.isLegendDisp"
                class="ml-1 mr-1"
              >
                <v-icon>import_contacts</v-icon>
                {{ btn.legend }}
              </v-btn>
            </v-row>
          </v-col>
        </v-col>
      </v-col>
    </div>
  </transition>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]水位 グラフダイアログ
 * TmStageGraphDlg.vue
 * @author LIS
 */

import TmStageGraph from "./TmStageGraph.vue";

export default {
  name: "tm-stage-graph-dlg",
  components: {
    TmStageGraph,
  },
  props: {
    /** 拡大/全体指定 */
    isExpansion: {
      type: Boolean,
      default: true,
    },
    /** 時間/10分指定 */
    isHour: {
      type: Boolean,
      default: true,
    },
    /** 凡例表示 */
    isLegend: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      /** 文字列リソース */
      text: {
        title: "水位グラフ",
        showRain: "雨量",
      },
      btn: {
        timehour: "時間毎",
        time10: "10分毎",
        zoomout: "全体",
        zoomin: "拡大",
        legend: "凡例",
      },
      width: 10,
      height: 10,
      showRain: true,
      showStage: true,
      graphSwitch: {
        selectTime: true,
        selectDisp: true,
        isLegendDisp: false,
      },
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeMount() {
    this.graphSwitch.selectTime = this.isHour;
    this.graphSwitch.selectDisp = this.isExpansion;
    this.graphSwitch.isLegendDisp = this.isLegend;

    this.handleResize();

    // 雨量観測所がない場合は、グラフ非表示
    if (!this.tmStageList.tmStgDetailInfo.reprnOfcCd) {
      this.showRain = false;
    } else {
      this.showRain = true;
    }
  },
  updated() {
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    /** 通常水位情報取得 */
    tmStageList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
  },
  methods: {
    handleResize() {
      this.$nextTick(() => {
        if (this.$refs.graphBox !== undefined) {
          const offsetWidth = this.$refs.graphBox.offsetWidth;
          const offsetHeight = this.$refs.graphBox.offsetHeight;
          if (offsetWidth > 0 && offsetHeight > 0) {
            this.width = offsetWidth - 48;
            this.height = offsetHeight - 167;
          }
        }
      });
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
